import { spacing } from '@fortum/elemental-ui'

/**
 * Default bottom margin for rich text block elements.
 */
export const BLOCK_BOTTOM_MARGIN = spacing.xs
